import { render } from "./ProgressBarLabel.vue?vue&type=template&id=608e592a"
import script from "./ProgressBarLabel.vue?vue&type=script&lang=js"
export * from "./ProgressBarLabel.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__